import { render } from "./VerificationModal.vue?vue&type=template&id=83f31756&scoped=true"
import script from "./VerificationModal.vue?vue&type=script&lang=js"
export * from "./VerificationModal.vue?vue&type=script&lang=js"

import "./VerificationModal.vue?vue&type=style&index=0&id=83f31756&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f31756"]])

export default __exports__